import React, { useState } from "react";
import { FlavorTab } from "./flavor-tab";
import { ImageModal } from "./image-modal";

export const Flavors = ({ data, flavorTab, setFlavorTab }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageUrl, imageName) => {
    setSelectedImage({ url: imageUrl, name: imageName });
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <div id="flavors" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Flavors</h2>
          <p>Choose your favorite.</p>
          <FlavorTab flavorTab={flavorTab} setFlavorTab={setFlavorTab} />
        </div>

        <div id="row">
          {data
            ? data
                .filter((item) => item.category === flavorTab)
                .map((d, i) => (
                  <div
                    key={`${d.name}-${i}`}
                    className="col-md-3 col-sm-6 team"
                  >
                    <div className="thumbnail">
                      <img
                        src={d.img}
                        alt={d.name}
                        className="team-img"
                        onClick={() => handleImageClick(d.img, d.name)}
                        style={{ cursor: "pointer" }}
                      />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        {/* <p>{d.job}</p> */}
                      </div>
                    </div>
                  </div>
                ))
            : "loading"}
        </div>
      </div>
      {selectedImage && (
        <ImageModal
          imageUrl={selectedImage.url}
          imageName={selectedImage.name}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};
